import React from 'react';
import { UnpackRecord } from '../../types/unpackRecord';
import { Box, BoxProps } from '../../wag-react/next-components/box';
export type Props = BoxProps & Required<Pick<BoxProps, 'children'>> & {
  id?: UnpackRecord<Pick<JSX.IntrinsicElements['div'], 'id'>>;
};
export const BackgroundImage = (props: Props) => <Box backgroundPosition="bottom" backgroundRepeat="no-repeat" backgroundSize="cover" {...props} data-sentry-element="Box" data-sentry-component="BackgroundImage" data-sentry-source-file="index.tsx" />;